import React, { Component } from 'react';
import './login.css';
import { connect } from 'react-redux';
import AuthPage from "../auth/authpage.component";
import Spinner from '../spinner/spinner.component';
import { pageViewEvent } from '../../helpers/general.helper';
import { Helmet } from 'react-helmet';
class Login extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
    }

    componentDidMount(){
        pageViewEvent('Autentificare - Cinemap','/autentificare');
    }

    render(){
        return (
            <div>
                <Helmet>
                    <title>Autentificare - Cinemap</title>
                    <meta name="description" content="Intră în clubul Cinemap și descoperă toate avantajele de care se bucură un user autentificat!"/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                <Spinner />
                <AuthPage />
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(Login);



// WEBPACK FOOTER //
// ./src/SHARED/components/login/login.component.js